import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead, prefillInquiry } from "@/components/Reveal";

const APPS = [
  {
    title: "Aerospace & Aviation",
    sub: "Every interface matters.",
    body: "A component earns its place through the requirements it meets. Discuss your geometry, material, inspection needs, and application with a manufacturer serving aerospace and aviation.",
    img: "https://images.unsplash.com/photo-1770733591838-5381c420dd7b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Small aircraft with blue accents inside a hangar (illustrative imagery)",
  },
  {
    title: "Defense",
    sub: "Start with the complete requirement.",
    body: "The drawing is one part of the conversation. Bring the specifications and program requirements that define how your component must be manufactured and documented.",
    img: "https://images.unsplash.com/photo-1792161019033-adbbff4c3636?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Military aircraft in a hangar (illustrative imagery)",
  },
  {
    title: "Communications & Electronics",
    sub: "Small features. Bigger connections.",
    body: "When a component belongs inside a larger system, fit and function start with the details. Discuss your precision-machined part or assembly with PMP.",
    img: "https://images.pexels.com/photos/39808538/pexels-photo-39808538.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Blue circuit board with microchips (illustrative imagery)",
  },
];

// I — Applications, three substantial cards linked to the inquiry with prefill.
export const Applications = () => (
  <section id="applications" data-testid="applications-section" className="on-light bg-[var(--cream-2)] py-24 sm:py-32">
    <div className="wrap">
      <SectionHead
        no="06"
        eyebrow="WHO WE SERVE"
        title={<>Different systems. <span className="font-serif-i">The same need to get the details right.</span></>}
      />

      <div className="mt-14 grid gap-5 lg:grid-cols-3">
        {APPS.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.08}>
            <button
              type="button"
              data-testid={`application-card-${i + 1}`}
              onClick={() => prefillInquiry({ application: a.title })}
              className="card group flex h-full w-full flex-col overflow-hidden p-0 text-left"
            >
              <div className="relative h-52 overflow-hidden sm:h-56">
                <img src={a.img} alt={a.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                <span className="absolute bottom-3 left-3 rounded-full bg-[#0b0e13]/75 px-3 py-1 font-mono text-[9px] tracking-[0.18em] text-white/90 backdrop-blur">
                  ILLUSTRATIVE IMAGERY
                </span>
              </div>
              <div className="flex flex-1 flex-col p-7">
                <h3 className="text-xl font-semibold tracking-[-0.02em] text-[var(--ink)]">{a.title}</h3>
                <p className="font-serif-i mt-1.5 text-lg text-[var(--blue)]">{a.sub}</p>
                <p className="mt-3 flex-1 text-[14.5px] leading-relaxed text-[var(--grey)] [text-wrap:pretty]">{a.body}</p>
                <span className="mt-6 flex items-center gap-1.5 font-mono text-[10.5px] tracking-[0.18em] text-[var(--ink-soft)] transition-colors group-hover:text-[var(--blue)]">
                  DISCUSS THIS APPLICATION
                  <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
